import { Injectable, EventEmitter } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { MISC_CONST } from '../../utils/const/misc';
import { AuthService } from '../../shared/services/features/oauth/auth.service';
import { environment } from 'environments/environment';
import { TokenStorage } from '@adeo/ngx-kozikaza-api';
import { UploadFile, UploadInput, humanizeBytes, UploadOutput } from "../../utils/kz-uploader";

@Injectable()
export class MediaService {

  public uploads = [];
  files: UploadFile[];
  uploadInput: EventEmitter<UploadInput>;
  // Todo : test by replacing humanizeBytes = () => {};
  humanizeBytes: Function;
  totalUploadSize = 0;
  private _progress: BehaviorSubject<number> = new BehaviorSubject(0);
  maxFileSize: number;

  public get progress(): Observable<number> {
    return this._progress.asObservable();
  }


  constructor(
    private authService: AuthService,
    private tokenStorage: TokenStorage
  ) {
    this.maxFileSize = MISC_CONST.POST_MAX_FILE_SIZE;
    this.files = []; // local uploading files array
    this.uploadInput = new EventEmitter<UploadInput>(); // input events, we use this to emit data to kz-uploader
    this.humanizeBytes = humanizeBytes;
  }

  public save(parameters: any): void {
    const event: UploadInput = {
      type: 'uploadAll',
      url: environment.API_BACKEND_ORIGIN + ((parameters && parameters.type == 'video') ? '/videos/upload' : '/media/upload'),
      method: 'POST',
      headers: {
        Authorization: `Bearer ${this.tokenStorage.token.accessToken}`
      },
      data: parameters
    };
    if (parameters.type && parameters.type === 'proService') {
      event.url = environment.API_BACKEND_ORIGIN + '/professionals/media';
      event.headers[`X-User-id`] = `${this.authService.getUserId().replace('/users/', '')}`;
    }
    this.uploadInput.emit(event);
  }

  public onUploadOutput(output: UploadOutput): void {
    if (output.type === 'addedToQueue') {
      this.totalUploadSize += output.file.size;

      this.files.push(output.file);
    } else if (output.type === 'uploading') {

      const index = this.files.findIndex(file => typeof output.file !== 'undefined' && file.id === output.file.id);
      this.files[index] = output.file;

      let progress = 0;
      this.files.forEach((f) => {
        progress += (f.progress.data.percentage * (f.size / this.totalUploadSize));
      });

      if (Math.floor(progress) > this._progress.getValue()) {
        this._progress.next(Math.floor(progress));
      }
    } else if (output.type === 'removed') {
      this.totalUploadSize -= output.file.size;
      this.files = this.files.filter((file: UploadFile) => file !== output.file);
    }
  }

  generateHash(length: number = 6, chars: string = 'abcdefghijklmnopqrstuvwxyz0123456789') {
    let hash = '';
    for (let i = length; i > 0; i--) {
      hash += chars[Math.floor(Math.random() * chars.length)];
    }
    return hash;
  }

  removeAllMedia(): void {
    this.files = [];
    this.totalUploadSize = 0;
    this._progress.next(0);
    this.uploadInput.emit({type: 'removeAll'});
    this.uploadInput.emit({type: 'cancelAll'});
  }
}
